import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { mainPageChatButtonSelector } from 'selectors/config';
import { TelegramIcon } from 'components/IconComponents/Telegram';
import { WhatsAppIcon } from 'components/IconComponents/WhatsApp';
import { EmailIcon } from 'components/IconComponents/Email';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps & ReturnType<typeof mainPageChatButtonSelector>;

const enhance = compose<Enhanced, Props>(translate, connect(mainPageChatButtonSelector));

const b = b_.with('main-page-contacts');

const Contacts: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()} data-testid={'main-page-contacts'}>
      <h2 className={b('title')}>{t('We answer any questions you may have about investments')}</h2>
      <div className={b('socials')}>
        <a
          href="https://t.me/ut_personal_manager_bot"
          className={b('item', { telegram: true })}
          target="_blank"
          rel="noopener"
          data-testid={'telegram-link'}
        >
          <TelegramIcon className={b('item-icon')} />
          <span>{t('Telegram')}</span>
        </a>

        <a
          href="https://wa.me/79959221420"
          className={b('item', { whatsapp: true })}
          target="_blank"
          rel="noopener"
          data-testid={'whatsapp-link'}
        >
          <WhatsAppIcon className={b('item-icon')} />
          <span>{t('WhatsApp')}</span>
        </a>

        <a
          href="mailto:welcome@unitedtraders.com"
          className={b('item', { email: true })}
          target="_blank"
          rel="noopener"
          data-testid={'email-link'}
        >
          <EmailIcon className={b('item-icon')} />
          <span>{t('Email post')}</span>
        </a>
      </div>
    </div>
  );
};

export default enhance(Contacts);
